import React, { forwardRef } from 'react';
import classNames from 'classnames';
import s from './index.module.scss';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

export const LendingColumns = ({
    isAdmin,
    changed,
    show,
    inTwoBlocks,
    threeBlocks,
    fourBlocks,
    twoBlocksNotEqual,
    twoBlocksNotEqualReverse,
    threeBlocksNotEqual,
    setShowColumns,
}) => {
    if (!show && !isAdmin) return null;
    return (
        <div
            className={classNames('lending-section', {
                'lending-section__dashed': isAdmin,
                'lending-section__dashed_changed': changed,
            })}
        >
            <div className={s.delete_wrap}>
                <Button
                    onClick={() => setShowColumns(false)}
                    className={s.delete_btn}
                    shape={'circle'}
                    icon={<PlusOutlined />}
                ></Button>
            </div>
            <div className={'lending-section__content'}>
                <div className={s.wrap}>
                    <div className={s.in_two} onClick={inTwoBlocks}>
                        <div className={s.in_two_item}></div>
                        <div className={s.in_two_item}></div>
                    </div>

                    <div className={s.three_blocks} onClick={threeBlocks}>
                        <div className={s.three_blocks_item}></div>
                        <div className={s.three_blocks_item}></div>
                        <div className={s.three_blocks_item}></div>
                    </div>

                    <div className={s.four_blocks} onClick={fourBlocks}>
                        <div className={s.four_blocks_item}></div>
                        <div className={s.four_blocks_item}></div>
                        <div className={s.four_blocks_item}></div>
                        <div className={s.four_blocks_item}></div>
                    </div>

                    <div
                        className={s.two_blocks_not_equal}
                        onClick={twoBlocksNotEqual}
                    >
                        <div className={s.two_blocks_not_equal_item}></div>
                        <div className={s.two_blocks_not_equal_item}></div>
                    </div>

                    <div
                        className={s.two_blocks_not_equal_reverse}
                        onClick={twoBlocksNotEqualReverse}
                    >
                        <div
                            className={s.two_blocks_not_equal_reverse_item}
                        ></div>
                        <div
                            className={s.two_blocks_not_equal_reverse_item}
                        ></div>
                    </div>

                    <div
                        className={s.three_blocks_not_equal}
                        onClick={threeBlocksNotEqual}
                    >
                        <div className={s.three_blocks_not_equal_item}></div>
                        <div className={s.three_blocks_not_equal_item}></div>
                        <div className={s.three_blocks_not_equal_item}></div>
                    </div>
                </div>
            </div>
        </div>
    );
};
